<template>
  <div>
    <!-- 周边停车场图标标题 -->
    <div v-if="needTitle" class="nearby-park-title">
      <img src="./../../assets/map/nearby-park.png" class="nearby-park-img">
      周边停车场
    </div>
    <!-- 条件选择后渲染的停车点位列表 -->
    <div
      v-for="(marker, index) in parkList"
      :key="index"
      class="list-item"
      @click="gotoParkDetail(marker)"
    >
      <!-- 停车场名称，isOnline是否在线 -->
      <div style="display:flex">
        <p class="park-name" :class="!marker.isOnline? '_gray':''">{{ marker.parkName }}</p>
        <!--导航-->
        <div class="list-right _mrauto" @click.stop="openBMap(marker)">
          <img src="./../../assets/map/navigation.png" class="list-right-img">
          <p class="list-right-center">{{ marker.distance | changeNum }}</p>
        </div>
      </div>
      <p class="park-add">{{ marker.parkAddr }}</p>
      <!-- 标签 默认都展示，不受标签筛选/在不在线影响-->
      <div class="type-list">
        <p v-if="marker.supportBag" class="park-fuctype flex_center">
          可包期
        </p>
        <p v-if=" marker.supportBook" class="park-fuctype flex_center">
          可预约
        </p>
        <p v-if="marker.supportCharge && btnList.chargingBerth" class="park-fuctype flex_center">
          可充电
        </p>
        <p v-if="marker.supportDiffTimeBag" class="park-fuctype flex_center">
          错时包月
        </p>
        <p v-if="marker.supportDiffTimeBook" class="park-fuctype flex_center">
          错时预约
        </p>
        <!-- 从收费规则提取出来的标签如：“30分钟免费”、“首小时5元”、“封顶20元” -->
        <p v-for="el in marker.feeRuleLabels" :key="el" class="park-fuctype _gray flex_center">
          {{ el }}
        </p>
      </div>
      <!-- marker.isTotal,  0-空闲车位/1-总车位数,，用于青岛项目展示总车位数，暂时不加 -->
      <div class="park-place">
        <img class="icon-place" src="./../../assets/map/iconPlace.png">
        <p class="space-num">
          <span>{{ marker.isOnline? marker.leftParkSpaceNum:'--' }} / </span><span>{{ marker.totalParkSpaceNum }}</span>
        </p>
        <!--可包期 可充电 可预约数值-->
        <p v-if="pardNumDetail(marker)" class="add-type" v-html="pardNumDetail(marker)" />
      </div>
      <!-- 车场描述 -->
      <div v-if="marker.description" class="parking-desc">
        <img class="icon-park" src="./../../assets/map/parkDetailIcon.png">
        <p>{{ marker.description }}</p>
      </div>
    </div>
    <!-- 无数据展示 -->
    <div v-if="!parkList.length" class="list-item">
      <div class="no-marker-list">
        <div class="img-wrapper">
          <img src="../../assets/order_no-permission.png">
        </div>
        <p>暂无符合条件的停车点位</p>
      </div>
    </div>
    <!-- 停车场地图导航 -->
    <div v-if="goMap" id="androidDialog2" class="js_dialog" style="opacity: 1">
      <div class="weui-mask" />
      <div class="weui-dialog weui-skin_android">
        <div class="weui-dialog__bd">确定对停车点进行导航么？</div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_default" @click.stop="goMap = false">取消</a>
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click.stop="primary('高德')"
          >高德地图</a>
          <a
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click.stop="primary('百度')"
          >百度地图</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { JumpToMapApp } from '@/utils/index.js'
import api from '@/api/map.js'
import api_mine from '@/api/mine.js'

export default {
  components: { },
  filters: {
    changeNum(val) {
      let num
      val > 999 ? (num = `${(val / 1000).toFixed(2)}km`) : (num = `${val}m`)
      return num
    }
  },
  props: {
    markers: {
      type: Array,
      default: () => []
    },
    needTitle: {
      type: Boolean,
      default: false
    },
    mapFlag: {
      type: Number,
      default: 2
    },
    // 可包期
    monthActive: {
      type: Boolean,
      default: false
    },
    // 可充电
    chargeActive: {
      type: Boolean,
      default: false
    },
    // 错时包月
    wrongTimePackage: {
      type: Boolean,
      default: false
    },
    // 错时预约
    wrongTimeSubscribe: {
      type: Boolean,
      default: false
    },
    // 可预约
    bookActive: {
      type: Boolean,
      default: false
    },
    // 经纬度
    lng: {
      type: [String, Number],
      default: ''
    },
    lat: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      parkList: [],
      btnList: {},
      goMap: false,
      parkItem: ''
    }
  },
  computed: {
    pardNumDetail() {
      return function(marker) {
        const res = []
        if (this.monthActive && marker.leftBagSpaceNum) {
          res.push(`可包期&nbsp;<span style="color: #000">${ marker.leftBagSpaceNum === -1 ? '无限制' : marker.leftBagSpaceNum}</span>`)
        }
        if (this.wrongTimePackage && (marker.diffTimeBagLeftNum || marker.diffTimeBagTotalNum)) {
          res.push(`${ marker.isOnline ? "可错时包月&nbsp;<span style='color: #000'>" + marker.diffTimeBagLeftNum + '</span>' : "总错时包月&nbsp;<span style='color: #000'>" + marker.diffTimeBagTotalNum + '</span>'}`)
        }
        if (this.wrongTimeSubscribe && (marker.diffTimeBookLeftNum || marker.diffTimeBookTotalNum)) {
          res.push(`${ marker.isOnline ? '可错时预约&nbsp;<span style="color: #000">' + marker.diffTimeBookLeftNum + '</span>' : '总错时预约&nbsp;<span style="color: #000">' + marker.diffTimeBookTotalNum + '</span>'}`)
        }
        if (this.bookActive && marker.leftBookSpaceNum) {
          res.push(`可预约&nbsp;<span style="color: #000">${ marker.leftBookSpaceNum === -1 ? '无限制' : marker.leftBookSpaceNum}</span>`)
        }
        return res.length ? '( ' + res.join(',') + ' )' : ''
      }
    }
  },
  watch: {
    lng() {
      this.getNearbyParks()
    },
    markers: {
      handler() {
        this.parkList = this.markers
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.parkList = this.markers
    // 获取菜单按钮权限
    api_mine.getMenu().then((resp) => {
      this.btnList = resp.data
    })
  },
  methods: {
    // 前往停车场详情
    gotoParkDetail(marker) {
      this.$emit('gotoParkDetail', marker.parkId)
    },
    // 点击导航
    openBMap(item) {
      this.parkItem = item
      if (this.mapFlag == 1) {
        this.primary('高德')
      } else if (this.mapFlag == 2) {
        this.primary('百度')
      } else if (this.mapFlag == 3) {
        this.goMap = true
      }
    },
    primary(val, item) {
      this.goMap = false
      const originPos = {
        lat: localStorage.getItem('lat'),
        lng: localStorage.getItem('lng')
      }
      JumpToMapApp(
        originPos,
        { lat: this.parkItem.latitude, lng: this.parkItem.longitude },
        this.parkItem.parkAddr,
        val
      )
      // let url = `http://api.map.baidu.com/direction?origin=latlng:${originPos.lat},${originPos.lng}|name:我的位置&destination=latlng:${item.latitude},${item.longitude}|name:${item.parkingName}&mode=driving&output=html&src=Hikvision|HikParking&coord_type=wgs84`;
      // window.location.href = url;
    },
    // 获取停车场详情
    getNearbyParks() {
      api.getNearbyParks({ destLng: this.lng, destLat: this.lat }).then((res) => {
        if (res.data && res.data.results) {
          // 停车场详情的周边车场只取前三个
          this.parkList = res.data.results.slice(1, 4)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.nearby-park-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  padding: 9px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);

  .nearby-park-img {
    width: 15px;
    height: 15px;
    margin-right: 6px;
  }
}
.list-item {
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .park-name {
    font-size: 16px;
    color: #333;
    font-weight: bold;
    &._gray{
      color: #999999;
    }
  }
  .park-add {
    font-size: 14px;
    color: #666;
  }
  .icon-park{
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
  .parking-desc {
    display: flex;
    align-items: center;
    margin-top: 4px;
    font-size: 12px;
    color: #999;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .type-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 14px;
  }
  .park-fuctype-content {
    display: flex;
    flex-direction: row;
  }

  .park-fuctype {
    background: rgba(65,130,244,0.10);
    border-radius: 3px;
    font-size: 12px;
    color: #3880FF;
    letter-spacing: 0;
    padding: 0 6px;
    width: fit-content;
    margin-top: 4px;
    margin-right: 6px;
    height: 24px;
    &._gray{
      background: rgba(124,145,180,0.10);
      color: #677B9D;
    }
  }
  .park-place{
    display: flex;
    font-size: 12px;
    color: #999999;
    align-items: center;
    .add-type{
      margin-left: 4px;
    }
    .icon-place{
      width: 40px;
      height: 25px;
    }

    .space-num {
      padding: 0px 6px;
      height: 25px;
      line-height: 25px;
      background: url("./../../assets/map/快充线.png") center no-repeat;
      background-size: 100% 100%;
      min-width: 50px;
      font-weight: 500;
      span:nth-child(1) {
        font-size: 14px;
        color: #3880FF;
        }
      }
  }
  .list-right {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    &._mrauto{
      margin-left: auto;
    }
    .list-right-img {
      width: 16px;
      height: 16px;
      margin-right: 2px;
    }

    .list-right-center {
      font-size: 12px;
      color: #666666;
      letter-spacing: 0;
    }
  }
}
  .no-marker-list {
    color: #666;
    font-size: 14px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;

    &:before {
      content: "";
      display: table;
    }

    .img-wrapper {
      width: 100px;
      height: 100px;
      margin: 40px auto 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  p{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
